import {DiscordContentFrameMessageData, DiscordCommand, DiscordEvent, DiscordCustomEvent, DiscordMountPopupType, DiscordUserPermissions, DiscordServerProfile} from '../../../../../../shared/DiscordActivityTypes'

export class DiscordMountContentFrameDispatcher {
    static sendReadyEvent(instanceId: string, serverId: string | null, userDiscordAccessToken: string, serverProfile: DiscordServerProfile, userPermissions: DiscordUserPermissions, referrerId: string | null, referralTypeId: string | null, isInitialLoad: boolean) {
        this.sendMessage({
            event: DiscordCustomEvent.Ready,
            command: DiscordCommand.DispatchDiscordEvent,
            data: {
                instanceId: instanceId,
                serverId: serverId,
                userDiscordAccessToken: userDiscordAccessToken,
                serverProfile: serverProfile,
                userPermissions: userPermissions,
                referrerId: referrerId,
                referralTypeId: referralTypeId,
                isInitialLoad: isInitialLoad,
            },
        })
    }

    static notifyCommandHasBeenHandled(messageId?: string, event?: string, subscription?: DiscordEvent, command?: DiscordCommand, data?: any) {
        this.sendMessage({
            messageId: messageId,
            event: event,
            subscription: subscription,
            command: command,
            data: data,
        })
    }

    static notifyWhenDiscordEventTriggers(subscription: DiscordEvent, eventData: any) {
        this.sendMessage({
            event: subscription,
            command: DiscordCommand.DispatchDiscordEvent,
            data: eventData,
        })
    }

    static notifyUserAlreadyHasMembershipError(error: any) {
        this.sendMessage({
            event: DiscordCustomEvent.CreateMountPopup,
            data: {
                popupType: DiscordMountPopupType.UserAlreadyHasMembershipError,
                error: error,
            },
        })
    }

    private static sendMessage(messageData: DiscordContentFrameMessageData) {
        const contentFrame = this.getContentFrame()
        contentFrame.contentWindow?.postMessage(messageData, '*')
    }

    private static getContentFrame() {
        const contentFrame = document.getElementById('content-frame') as HTMLIFrameElement
        if(contentFrame == null) {
            throw new Error('Content Frame not found')
        }
        return contentFrame
    }
}
